import React from "react";
import { Mail } from "lucide-react";

/**
 * Compact reusable opt-in checkbox used across all registration forms.
 * Value is a plain boolean; parent owns state.
 */
export default function EmailOptInCheckbox({ checked, onChange, testId = "email-opt-in" }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none border border-white/10 bg-black/40 px-3 py-3 mb-3 hover:border-white/20 transition-colors" data-testid={testId}>
      <input
        type="checkbox"
        checked={!!checked}
        onChange={e => onChange(e.target.checked)}
        className="mt-0.5 accent-red-600"
        data-testid={`${testId}-input`}
      />
      <span className="text-xs text-zinc-300 leading-relaxed">
        <span className="inline-flex items-center gap-1 mr-1 text-white uppercase tracking-widest text-[10px]">
          <Mail size={11}/> Keep me in the loop
        </span>
        I'd like to receive class reminders, term-start nudges, and occasional updates from 2RightFeet.
        <span className="block text-[10px] text-zinc-500 mt-1">
          You'll always get your booking confirmation regardless — this only controls marketing / reminder emails.
        </span>
      </span>
    </label>
  );
}

/** Small red asterisk with screen-reader label, used to mark required inputs. */
export function RequiredMark() {
  return <span className="text-red-500 ml-0.5" aria-label="required">*</span>;
}
